module.exports = __webpack_public_path__ + "img/coupon_usedemo.b11fb9c0.png";